import { defaultIconColor } from '../constants';
import { SVGComponentPropsType } from 'assets/types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <g stroke={color} strokeWidth="2" fill="none" fillRule="evenodd">
      <path d="M3 14a3 3 0 0 0 3 3h4a1 1 0 0 0 1-1v-2h8l2-2-2-2h-8V8a1 1 0 0 0-1-1H6a3 3 0 0 0-3 3v4zM17 14v-2M14 14v-2M7 14v-4" />
    </g>
  </svg>
);
